// Vendor
import './_sass/style.scss';
// Modules
import ModuleLoader from './utils/moduleLoader';
import polyfills from './utils/polyfills';
import Nav from './modules/nav';
import HomeSlider from './modules/homeSlider';

class App {
	constructor () {
		this.loader = new ModuleLoader({
			Nav,
			HomeSlider
		});

	}

	render () {
		this.loader.load();

		console.log('ready');

		return this;
	}
}

window.app = new App().render();